import React from 'react'
import Contact from '../components/Contact'

const ContactMobile = () => {
  return (
    <div>
        <Contact/>
    </div>
  )
}

export default ContactMobile